import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
